// Added by Sejune Oh on 2020-04-06
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import React, { FC } from 'react';
import {
    TableHead as MaterialUITableHead,
    TableHeadProps as MaterialUITableHeadProps
} from '@material-ui/core'

interface TableHeadBaseProps { }
export type TableHeadProps = Partial<MaterialUITableHeadProps> & TableHeadBaseProps

export const TableHead: FC<TableHeadProps> = ({ ...props }) => {
    return <MaterialUITableHead {...props}></MaterialUITableHead>
}
